//# sourceMappingURL=administration.mjs.map
/// <reference types="./administration.d.mts" />
import * as $redraw from "../../redraw/redraw.mjs";
import * as $route from "../data/route.mjs";
import * as $jobs from "../view/administration/jobs.mjs";
import * as $label_translations from "../view/administration/label_translations.mjs";
import * as $llm_capacity from "../view/administration/llm_capacity.mjs";
import * as $maintenance from "../view/administration/maintenance.mjs";
import * as $model_assignments from "../view/administration/model_assignments.mjs";
import * as $websites from "../view/administration/websites.mjs";

export function view() {
  return $redraw.compose(
    $maintenance.view(),
    (maintenance) => {
      return $redraw.compose(
        $label_translations.view(),
        (label_translations) => {
          return $redraw.compose(
            $model_assignments.view(),
            (model_assignments) => {
              return $redraw.compose(
                $llm_capacity.view(),
                (llm_capacity) => {
                  return $redraw.compose(
                    $jobs.view(),
                    (jobs) => {
                      return $redraw.compose(
                        $websites.view(),
                        (websites) => {
                          return $redraw.component_(
                            "Administration",
                            (_use0) => {
                              let route = _use0[0];
                              if (route instanceof $route.Maintenance) {
                                return maintenance(undefined);
                              } else if (
                                route instanceof $route.ChoiceTranslations
                              ) {
                                return label_translations(undefined);
                              } else if (
                                route instanceof $route.SectionTranslations
                              ) {
                                return label_translations(undefined);
                              } else if (
                                route instanceof $route.ModelAssignments
                              ) {
                                return model_assignments(undefined);
                              } else if (route instanceof $route.LlmCapacity) {
                                let tab = route[0];
                                return llm_capacity([tab]);
                              } else if (route instanceof $route.Jobs) {
                                return jobs(undefined);
                              } else {
                                return websites(undefined);
                              }
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
